<template>
  <Tile
    :name="name"
    icon="download-file"
    clickable
    :image="image"
    :dark-image-bg="composition.properties.darkBackground"
    class="publishing-tile"
    @on-click="edit"
  >
    <template v-if="designCount > 1" #overlay>
      <div class="overlay">
        <Badge type="neutral">
          {{
            `${$t('DESIGNS.CONFIGURATION.EDITOR.TAB_PRINTAREAS')}: ${designCount}`
          }}
        </Badge>
      </div>
    </template>
    <template v-if="displayPosStatus" #status>
      <CompositionPosStatusBadges
        class="badges"
        :composition="composition"
        :relevant-pos-types="relevantPosTypes"
        :relevant-pos-states="relevantPosStates"
        :hide-icon="relevantPosTypes.length <= 1"
      />
    </template>
  </Tile>
</template>

<script>
import compositionHelper from 'commons/composition/compositionHelper';
import Tile from 'commons/tileView/Tile.vue';
import CompositionPosStatusBadges from 'src/app/components/publishing/statusBadges/CompositionPosStatusBadges.vue';
import Badge from 'src/app/components/badge/Badge.vue';

export default {
  name: 'PublishingTile',
  components: {
    Badge,
    Tile,
    CompositionPosStatusBadges,
  },
  props: {
    composition: {
      required: true,
      type: Object,
    },
    displayPosStatus: {
      type: Boolean,
    },
    relevantPosTypes: {
      type: Array,
    },
    relevantPosStates: {
      type: Array,
    },
  },
  emits: ['edit'],
  computed: {
    name() {
      return (
        compositionHelper.getMetaDataPart({
          composition: this.composition,
          part: 'name',
        })?.value || this.composition.id
      );
    },
    image() {
      return compositionHelper.getMainDesignImage(this.composition);
    },
    designCount() {
      return this.composition.designs?.length || 0;
    },
  },
  methods: {
    edit() {
      this.$emit('edit');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/mixins/media';
@import 'src/scss/styleguide/type';

.publishing-tile {
  height: 100%;

  :deep(.card-footer) {
    height: auto;
  }

  .badges {
    margin: 12px 0 0 0;
  }

  .overlay {
    position: absolute;
    bottom: 8px;
    left: 8px;
    font-size: 0.75em;
  }
}
</style>
